<template>
    <v-flex xs12 text-xs-center>
        <template v-if="loading">
            <v-card>
                <v-divider></v-divider>
                <v-progress-linear indeterminate color="primary" height="15"></v-progress-linear>
                <v-divider></v-divider>
            </v-card>
        </template>
        <v-card v-else>
            <v-card-title class="title font-weight-bold white--text primary">                
                {{ details.DivisionName }}: {{ details.LocationName }}                
            </v-card-title>
            <v-divider></v-divider>
            <v-layout row wrap>
                <v-flex xs12 sm6 md6 lg5 xl4>                        
                    <v-list dense>
                        <v-list-tile>
                            <v-list-tile-content>Name:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ details.Name }}</v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content>Score:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ details.Observation }}</v-list-tile-content>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content>Notes:</v-list-tile-content>
                            <v-list-tile-content class="align-end">{{ details.Notes }}</v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-flex>
            </v-layout>
        </v-card>
    </v-flex>
</template>
<script>
import scoutApi from '@/api/scoutApi';

export default {
    data() {
        return {
            loading: false,
            details: {}
        }
    },
    props: [
        "id"
    ],
    methods: {
        async load(id) {
            this.loading = true;

            this.details = await scoutApi.getScoutingOverview(id);

            this.loading = false;
        }
    },
    async mounted() {
        await this.load(this.id);
    }
}
</script>